module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 item-right"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png",
      "id": "brand-logo"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Sign Up")]), _vm._v(" "), _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    attrs: {
      "type": "submit",
      "disabled": !_vm.isValidEmail
    }
  }, [_vm._v("LOGIN")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPleaseWait == true) ? _c('p', [_vm._v("Please wait...")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showMessage == true) ? _c('h5', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.displayMsg) + "\n          ")]) : _vm._e()])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f032c22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup.vue
// module id = 1480
// module chunks = 1